import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { month: 'Jan', actives: 12, suspendues: 2 },
  { month: 'Fév', actives: 15, suspendues: 1 },
  { month: 'Mar', actives: 18, suspendues: 3 },
  { month: 'Avr', actives: 20, suspendues: 2 },
  { month: 'Mai', actives: 22, suspendues: 1 },
  { month: 'Juin', actives: 25, suspendues: 2 },
];

export const AgencyActivityChart: React.FC = () => {
  return (
    <div className="h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar name="Agences actives" dataKey="actives" fill="#0a8345" />
          <Bar name="Agences suspendues" dataKey="suspendues" fill="#ef4444" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};